export default function (instance) {
    return {
        getApiKey(){
            return instance.get('payment/apikey')
        },
        getCards(){
            return instance.get('payment/cards')
        },
        checkInvoice(payload){
            return instance.get('payment/check-by-invoice', payload)
        },
        createInvoice(payload){
            return instance.postForm('payment/invoice', payload)
        },
        pay(payload){
            return instance.postForm('payment/pay', payload)
        },
        promocode(payload){
            return instance.get('promocode', payload)
        },
    }
}